module.exports = __webpack_public_path__ + "img/20190705162042862.83b6c398.png";